// extracted by mini-css-extract-plugin
export default {"cart-list":"CartList_cart-list__50WVk"};